
import { Vue, Component } from 'vue-property-decorator'
import { Global } from '@/store'

@Component
export default class Main extends Vue {
  get user(){ return Global.user }
}
